import OTPResendTimer from "./OTPResendTimer";
export default OTPResendTimer;